import { render, staticRenderFns } from "./ConfigFieldDialog.vue?vue&type=template&id=dbdc77b0&"
import script from "./ConfigFieldDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigFieldDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports